const clamp = (value, low, high) => Math.max(low, Math.min(high, value));

/** Presentation-only, finite camera accents. Input dt is visible seconds; accepted
 * event IDs prevent duplicate kicks. Reduced motion removes every accent and
 * terminal movement. This never changes course coordinates or gameplay time. */
export function createBobCameraMotion() {
  let serial = 0,
    elapsed = -1,
    level = null;
  let spring = 0,
    reward = 0,
    finishAge = 0,
    boost = 0;
  return {
    update(state, dt, reduced) {
      const reset = state.level !== level || state.elapsed < elapsed || state.eventSerial < serial;
      if (reset) {
        serial = 0;
        spring = reward = finishAge = boost = 0;
      }
      level = state.level;
      elapsed = state.elapsed;
      const delta = clamp(Number(dt) || 0, 0, 0.05);
      spring *= Math.exp(-delta * 2.8);
      reward *= Math.exp(-delta * 4.2);
      if (spring < 0.0001) spring = 0;
      if (reward < 0.0001) reward = 0;
      for (const event of state.events || []) {
        if (event.id <= serial) continue;
        serial = event.id;
        if (event.type === 'spring') spring = 1;
        if (event.type === 'arcade' || event.type === 'bonus-route') reward = 1;
      }
      finishAge = state.status === 'complete' ? Math.min(1, finishAge + delta / 0.8) : 0;
      const powered = state.status === 'playing' && state.effects?.boostUntil > state.elapsed;
      boost += ((powered ? 1 : 0) - boost) * (1 - Math.exp(-delta * 3));
      if (reduced) return { x: 0, lift: 0, distance: 0, lookLift: 0, fov: 48, roll: 0, finish: 0 };
      const finish = finishAge * finishAge * (3 - 2 * finishAge);
      return {
        finish,
        x: clamp(state.bob.vx * 0.055, -0.24, 0.24) + finish * 1.6,
        lift: spring * 0.48 + finish * 0.55,
        distance: boost * 0.8 + spring * 0.38 - finish * 0.9,
        lookLift: Math.min(1.25, Math.max(0, state.bob.y - 3) * 0.13) + finish * 0.35,
        fov: 48 + boost * 3.5 + spring * 1.1 + reward * 0.65,
        roll: clamp(-state.bob.vx * 0.0015, -0.009, 0.009),
      };
    },
  };
}
